export enum TNotificationType {
  NewOffer = 'new-offer',
  AcceptedOffer = 'accepted-offer',
}

export type TNotification = {
  ID: string
  Holder: string
  Created: string

  Type: TNotificationType
  Title: string
  Message: string
  Link?: string
  Seen?: boolean
}
